import { useState } from 'react';

/**
 * Custom hook for managing processing state in AdminDashboard
 * Tracks which actions are currently being processed to show loading indicators
 * 
 * @returns {Object} Object containing processing state and setters
 */
export const useProcessingState = () => {
    const [processingCell, setProcessingCell] = useState(null); // userId-organizationId for relationship cells
    const [processingAction, setProcessingAction] = useState(null); // userId or organizationId for directory actions

    return {
        processingCell,
        setProcessingCell,
        processingAction,
        setProcessingAction
    };
};
